import { useEffect } from 'react';

import { SentryUserContext } from '../utils/sentry-user-context';
import { useUser } from './use-user';

/**
 * Effect hook that initializes and synchronizes authenticated user information with Sentry.
 * This enables Sentry to associate errors with specific users for better debugging.
 */
export function useInitSentryUserEffect() {
  const { user } = useUser();

  useEffect(() => {
    if (user) {
      // Set user context in Sentry
      SentryUserContext.setUser(user);
    } else {
      // Clear user context when not authenticated
      SentryUserContext.clearUser();
    }
  }, [user]);
}
